import { MS_IN_SECOND, dailySpinChainId } from '@/constants/shared';
import { DAILY_SPIN_ABI } from '@/network/abi/daily-spin';
import { occurredToday } from '@/utils';
import { useAppKitAccount } from '@reown/appkit/react';
import { useReadContract } from 'wagmi';

export const useDailySpinOnchain = () => {
  const { address } = useAppKitAccount();
  const {
    data,
    isLoading: isLoadingDailySpinStats,
    error,
    refetch,
  } = useReadContract({
    address: import.meta.env.VITE_DAILY_SPIN_CONTRACT_ADDRESS,
    abi: DAILY_SPIN_ABI,
    chainId: dailySpinChainId,
    functionName: 'getUserData',
    args: [address as EthAddress],
    query: {
      refetchOnMount: true,
    },
  });

  const [
    dailySpinStreak,
    lastSpunAtTimestampSeconds,
    jackpotsWon,
    raffleTicketsWon,
    raffleTicketsBalance,
    xpWon,
    plumeTokensWon,
  ] = data?.map(Number) ?? [0, 0, 0, 0, 0, 0, 0];
  const lastSpunAtTimestampMs = Number(lastSpunAtTimestampSeconds ?? 0) * MS_IN_SECOND;
  return {
    dailySpinStreak,
    lastSpunAtTimestamp: lastSpunAtTimestampMs,
    jackpotsWon,
    raffleTicketsWon,
    raffleTicketsBalance,
    xpWon,
    plumeTokensWon,
    hasSpunToday: occurredToday(new Date(lastSpunAtTimestampMs)),
    isLoadingDailySpinStats,
    error,
    refetchDailySpinStats: refetch,
  };
};
